export default {
  "content": "<g clip-path=\"url(#a)\"><path d=\"M5.42.833c.2-.206.533-.22.747-.02l6.7 6.24c.3.28.466.674.466 1.08-.006.407-.18.8-.486 1.074l-6.654 5.966a.534.534 0 01-.746-.033l-.594-.64a.54.54 0 01.034-.76l6.286-5.627L4.84 2.22a.53.53 0 01-.02-.76z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};